<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-school" data-bs-toggle="modal" data-bs-target="#school-modal-form">Klik</button>
        <div class="modal" id="school-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="form-group form-style-1">
                                    <label class="form-label">Nama Sekolah<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control error" placeholder="Masukan nama sekolah" v-model="form.name" required oninvalid="this.setCustomValidity('Masukan nama sekolah')" oninput="this.setCustomValidity('')">
                                </div>                                
                                <div class="form-group">
                                    <label class="form-label">Provinsi<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <v-select
                                        :options="listProvince"
                                        label="name"
                                        v-model="form.province"
                                        placeholder="Pilih Provinsi"
                                        @input="getCity"
                                        >
                                        <template #search="{attributes, events}">
                                            <input
                                            class="vs__search"                                            
                                            :required="!form.province"
                                            v-bind="attributes"
                                            v-on="events"
                                            />
                                        </template>
                                    </v-select>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Kota<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <v-select
                                        :options="listCity"
                                        label="name"
                                        v-model="form.city"
                                        placeholder="Pilih Kota">
                                        <template #search="{attributes, events}">
                                            <input
                                            class="vs__search"
                                            :required="!form.city"
                                            v-bind="attributes"
                                            v-on="events"
                                            />
                                        </template>
                                    </v-select>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">NPSN<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan NPSN" v-model="form.npsn" required oninvalid="this.setCustomValidity('Masukan NPSN')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Nilai Index<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan nilai index" v-model="form.index_score" required oninvalid="this.setCustomValidity('Masukan nilai index')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="form-label">Status<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-select-wrapper form-select-style-1">
                                                        <i class="fa-solid fa-caret-down"></i>
                                                        <select class="form-select form-select-box-1" v-model="form.partner" required oninvalid="this.setCustomValidity('Pilih jenis mitra')" oninput="this.setCustomValidity('')">
                                                        <option value="">Jenis Mitra</option>
                                                            <option value="1">Mitra</option>
                                                            <option value="0">Bukan Mitra</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="form-label">Akreditasi<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-select-wrapper form-select-style-1">
                                                        <i class="fa-solid fa-caret-down"></i>
                                                        <select class="form-select form-select-box-1" v-model="form.accreditation" required oninvalid="this.setCustomValidity('Pilih Akreditasi')" oninput="this.setCustomValidity('')">
                                                            <option value="">Pilih Akreditasi</option>
                                                            <option value="A">A</option>
                                                            <option value="B">B</option>
                                                            <option value="C">C</option>
                                                            <option value="D">D</option>
                                                            <option value="E">E</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-school">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'SchoolForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id           : "",
                name         : "",
                province     : "",
                city         : "",
                npsn         : "",
                index_score  : "",
                partner      : "",
                accreditation : "",
            },
            listProvince    : [],
            listCity        : [],
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            province: {
                required
            },
            city: {
                required
            },
            npsn: {
                required
            },
            index_score: {
                required
            },
            partner: {
                required
            },
            accreditation: {
                required
            }
        }
    },
    methods: {
        loadForm: function(params="") {
            this.getProvince();

            if(params == '') {
                this.label = 'Tambah';
                this.clearForm();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-school').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-school').click();
            this.$parent.$children[0].$children[0].getData();
            this.clearForm();
        },
        clearForm: function() {
            for (let key in this.form) {
                this.form[key] = '';
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    if(key == 'province' || key == 'city') {                        
                        formData.append(key, JSON.stringify(this.form[key]));
                    } else {
                        formData.append(key, this.form[key]);
                    }
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'school/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'school/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];
                            }
                        }
                    }
                });
            }
        },
        getProvince: function () {
            let uri = 'https://somme.scola.id/region/province';
            
            this.$http.get(uri).then(res => {
                let getResponse = res.data;
                this.listProvince = getResponse.data;
                this.getCity();
            });
        },
        getCity: function() {
            this.listCity = [];
            this.form.city = "";
            if(this.form.province) {
                if(this.form.province.id) {
                    let uri = 'https://somme.scola.id/region/province_detail';
                    this.$http.get(uri, {
                        params: {
                            type: 'city',
                            id_province : this.form.province.id
                        }
                    }
                    ).then(res => {
                        let getResponse = res.data;
                        this.listCity = getResponse.data;
                    });
                }
            }
        }
    },
}
</script>
